import { commonActionCreator } from '@confluence-classic/confluence-legacy-redux';

export const closeActiveModal = commonActionCreator('CLOSE_ACTIVE_MODAL');
export const setActiveModal = commonActionCreator('SET_ACTIVE_MODAL');
